module.exports = __webpack_public_path__ + "static/media/wizualizacja-23.f48079b3.png";